import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Icon, Checkbox, Select, InputNumber, Radio } from 'antd';
import { User } from '../../../../models';
import TextArea from 'antd/lib/input/TextArea';
import { Text3 } from '../../../../styles';


let UserForm = (props) => {
    const { form, user } = props;
    const { getFieldDecorator } = form;
    const validations = User.validations;
    const [checkList, setCheckList] = useState({ "maker": false, "checker": false, "approver": false })
    const spending_limit_rules= [
        { required: true, message: "Amount is required" },
            { pattern: '^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$', message: "Please enter a valid amount." }
        ]
    const [enablePayoutLimit,setenablePayoutLimit]=useState(false)

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            props.onSubmit(form.getFieldsValue());
        });
    };

    const handleCheckboxChange = (e) => {
        let type = e.target.value
        let arr = { ...checkList }
        if (type == 'maker') {
            arr[type] = e.target.checked
            arr['checker'] = false
            arr['approver'] = false
        } else if (type == 'checker') {
            arr['maker'] = e.target.checked
            arr[type] = e.target.checked
            arr['approver'] = false
        } else if (type == 'approver') {
            arr['maker'] = e.target.checked
            arr['checker'] = e.target.checked
            arr[type] = e.target.checked
        }
        setCheckList(arr)
    }

    useEffect(() => {
        if(user){
            form.setFieldsValue({'spending_limit':user?.spending_limit?.toString()})
            setenablePayoutLimit(user.enable_spending_limit)
        }
        if (user.role){
            let arr = { ...checkList }
            Object.keys(arr).map(() => {
                if (user.role == 1) {
                    arr['maker'] = true
                }
                if (user.role == 2) {
                    arr['maker'] = true
                    arr['checker'] = true
                }
                if (user.role == 3) {
                    arr['maker'] = true
                    arr['checker'] = true
                    arr['approver'] = true
                }
            })
            setCheckList(arr)
        }
        
    }, [])

    const renderBasicForm = () => {
        return (
            <div>
                <div>
                    {getFieldDecorator("id", {
                        initialValue: user.id,
                        rules: validations.id
                    })(<Input autoComplete='off' hidden />)}

                    <Form.Item label="Name">
                        {getFieldDecorator("name", {
                            initialValue: user.name,
                            rules: validations.name
                        })(<Input autoComplete='off' prefix={<Icon type="user" />} />)}
                    </Form.Item>

                    <Form.Item label="Email ID">
                        {getFieldDecorator("email", {
                            initialValue: user.email,
                            rules: validations.email
                        })(<Input autoComplete='off' disabled={user.is_edit} prefix={<Icon type="mail" />} />)}
                    </Form.Item>

                    <Form.Item label="Phone No.">
                        {getFieldDecorator("phone", {
                            initialValue: user.phone,
                            rules: validations.phone
                        })(<Input autoComplete='off' prefix={<Icon type="phone" />} />)}
                    </Form.Item>
 
                    <Form.Item label="Level">
                        {getFieldDecorator('level', { initialValue: user.level })(
                            <Select>
                                {
                                    ["L1", "L2", "L3", "L4", "L5"].map(level =>
                                        <Select.Option value={level}>{level}</Select.Option>
                                    )
                                }
                            </Select>
                        )}
                    </Form.Item>
                    <Form.Item style={{marginBottom:"5px"}}>
                        {getFieldDecorator('role', { initialValue: Object.values(checkList).filter(Boolean).length })(
                            <>
                                <Checkbox value={`maker`} checked={checkList['maker']} onChange={handleCheckboxChange}>{'Maker'}</Checkbox>
                                <Checkbox value={`checker`} checked={checkList['checker']} onChange={handleCheckboxChange}>{'Checker'}</Checkbox>
                                <Checkbox value={`approver`} checked={checkList['approver']} onChange={handleCheckboxChange}>{'Approver'}</Checkbox>
                            </>
                        )}
                    </Form.Item>
                    <div>
                    <Form.Item   style={{marginBottom:"0"}}>
                    {getFieldDecorator("enable_spending_limit",{ initialValue: user.enable_spending_limit })(<Checkbox value={true} checked={enablePayoutLimit} onChange={()=>setenablePayoutLimit(!enablePayoutLimit)} >Enable Payout Limit</Checkbox>)}
                    </Form.Item>
                    <Form.Item label="Payout Limit" >

                        {getFieldDecorator("spending_limit",{rules: enablePayoutLimit? spending_limit_rules:null})(<Input disabled={!enablePayoutLimit}  className="w-100" placeholder='Enter Amount'  />)}
                    </Form.Item>
                    </div>
                </div>
            </div>
        )
    };

    return (
        <Form onSubmit={onSubmit}>
            <div className="row">
                <div className="col-sm">{renderBasicForm()}</div>
            </div>
            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={props.loading}>{user.is_edit ? "Update" : "Create"}</Button>
            </div>
        </Form>
    )
};

UserForm = Form.create()(UserForm);
export { UserForm };